module.exports = __webpack_public_path__ + "img/Frame 5121.0f2554e0.jpg";